import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header.jsx';
import Hero from './components/Hero.jsx';
import About from './components/About.jsx';
import Schedule from './components/Schedule.jsx';
import Pricing from './components/Pricing.jsx';
import Location from './components/Location.jsx';
import Gallery from './components/Gallery.jsx';
import Footer from './components/Footer.jsx';
import FAQPage from './pages/FAQPage.jsx';
import TeachersPage from './pages/TeachersPage.jsx';

function DojoLanding() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <About />
        <Schedule />
        <Pricing />
        <Location />
        <Gallery />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DojoLanding />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/professeurs" element={<TeachersPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;